(function() {
    var qs = (function(a) {
        if (a == "") return {};
        var b = {};
        for (var i = 0; i < a.length; ++i)
        {
            var p=a[i].split('=', 2);
            if (p.length == 1)
                b[p[0]] = "";
            else
                b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
        }
        return b;
    })(window.location.search.substr(1).split('&'));

    var makeReferrerRequest = function() {
        var url = '/affiliate-window-session';
        var data = encodeURIComponent( 'awc' ) + '=' + encodeURIComponent( qs['awc'] );
        try {
            x = new(this.XMLHttpRequest || ActiveXObject)('MSXML2.XMLHTTP.3.0');
            x.open('POST', url, 1);
            x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            x.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            x.onreadystatechange = function () {
                if (x.readyState > 3) {
                    if (x.status == 200) {
                        console.log(JSON.parse(x.responseText));
                    } else {
                        console.log(x.status + ' status returned');
                    }
                }
            };
            x.send(data)
        } catch (e) {
            window.console && console.log(e);
        }
    };

    if (typeof qs['awc'] != 'undefined') {
        makeReferrerRequest();
    }
})();

